import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Avatar,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Fade,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    makeStyles,
    Paper,
    Popper,
    Typography,
    useTheme
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { IconLogout, IconSettings } from '@tabler/icons';
import AdminUserDataService from '../../../../../DataAccess/AdminUserDataService';

import * as actionTypes from '../../../../../Redux/Action/BackboneAction';


import User1 from './../../../../assets/images/users/user.png';
import { SessionHelper } from '../../../../../Core';
import { RootReduxState } from '../../../../../Redux/Store';



const useStyles = makeStyles((theme) => ({
    navContainer: {
        width: '100%',
        maxWidth: '250px',
        minWidth: '200px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '10px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '100%'
        }
    },
    headerAvtar: {
        cursor: 'pointer',
        ...theme.typography.mediumAvatar,
        margin: '8px 0 8px 8px !important'
    },
    profileChip: {
        height: '48px',
        alignItems: 'center',
        borderRadius: '27px',
        transition: 'all .2s ease-in-out',
        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light,
        '&[aria-controls="menu-list-grow"], &:hover': {
            borderColor: theme.palette.primary.main,
            background: theme.palette.primary.main + '!important',
            color: theme.palette.primary.light,
            '& svg': {
                stroke: theme.palette.primary.light
            }
        }
    },
    profileLabel: {
        lineHeight: 0,
        padding: '12px'
    },
    listItem: {
        marginTop: '5px'
    },
    cardContent: {
        padding: '16px !important'
    },
    card: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light,
        marginBottom: '16px',
        marginTop: '16px'
    },
    searchControl: {
        width: '100%',
        paddingRight: '8px',
        paddingLeft: '16px',
        marginBottom: '16px',
        marginTop: '16px'
    },
    startAdornment: {
        fontSize: '1rem',
        color: theme.palette.grey[500]
    },
    flex: {
        display: 'flex'
    },
    name: {
        marginLeft: '2px',
        fontWeight: 400
    },
    ScrollHeight: {
        height: '100%',
        maxHeight: 'calc(100vh - 250px)',
        overflowX: 'hidden'
    },
    badgeyellow: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.warning.dark,
        color: '#fff'
    }
}));

const ProfileSection = () => {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const dispatch = useDispatch();
    const customization = useSelector((state: RootReduxState) => state.customization);


    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLDivElement>(null);
    const handleLogout = async () => {
        try {
            var props = {
                history: history
            }
            // End the server-side admin session too (best effort).
            await AdminUserDataService.LogOut(AdminUserDataService.GetBaseRequestModel()).catch(() => undefined);
            SessionHelper.Logout(props);
            //await logout();
        } catch (err) {
            console.error(err);
        }
    };

    const _handleChangeProfileChange = (_event: React.MouseEvent<HTMLElement>) => {

    }

    const _handleThemeChange = () => {
        console.log("here handleThemeChange ")
        setOpen(!open)
        dispatch({ type: actionTypes.SET_CUSTOMISE_SIDEBAR_OPEN, Data: true })
    }
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event: React.MouseEvent<Document> | React.TouchEvent<Document>) => {
        if (anchorRef.current && event.target instanceof Node && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current?.focus();
        }

        prevOpen.current = open;
    }, [open]);
    var session = SessionHelper.GetSession()
    return (
        <React.Fragment>
            <Chip
                classes={{ label: classes.profileLabel }}
                className={classes.profileChip}
                icon={
                    <Avatar
                        src={User1}
                        className={classes.headerAvtar}
                    />
                }
                label={
                    <IconSettings
                        stroke={1.5}
                        size="1.5rem"
                        color={theme.palette.mode === 'dark' ? theme.palette.dark.light : theme.palette.primary.main}
                    />
                }
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: {
                        offset: {
                            offset: '0, 10'
                        }
                    }
                }}
            >
                {({ TransitionProps, placement }) => (
                    <Fade {...TransitionProps}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <Card elevation={16}>
                                    <CardContent className={classes.cardContent}>
                                        <Grid container direction="column" spacing={0}>
                                            <Grid item className={classes.flex}>
                                                <Typography variant="h4">Welcome, </Typography>
                                                <Typography component="span" variant="h4" className={classes.name}>
                                                    {session?.Name || "Demo User"}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle2">
                                                    {session?.RoleName || "Super Admin"}
                                                </Typography>
                                            </Grid>
                                        </Grid>


                                        <Divider />

                                        <List component="nav" className={classes.navContainer}>
                                            <ListItem
                                                className={classes.listItem}
                                                style={{ borderRadius: customization.borderRadius + 'px' }}
                                                button
                                                onClick={() => { setOpen(false); history.push('/profile'); }}
                                            >
                                                <ListItemIcon>
                                                    <IconSettings stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">My Profile</Typography>} />
                                            </ListItem>
                                            <ListItem
                                                className={classes.listItem}
                                                style={{ borderRadius: customization.borderRadius + 'px' }}
                                                button
                                                onClick={handleLogout}
                                            >
                                                <ListItemIcon>
                                                    <IconLogout stroke={1.5} size="1.3rem" />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                                            </ListItem>
                                        </List>

                                    </CardContent>
                                </Card>
                            </ClickAwayListener>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </React.Fragment>
    );
};

export default ProfileSection;
